import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-33804682")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createBlock(_component_Calendar, {
    "manual-input": false,
    "month-navigator": true,
    "year-navigator": true,
    yearRange: _ctx.yearRange,
    modelValue: _ctx.selected,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected = $event)),
    class: "p-mb-2",
    dateFormat: "yy/mm/dd",
    maxDate: new Date()
  }, null, 8, ["yearRange", "modelValue", "maxDate"]))
})